
import { globalSet } from 'app/utils';

/*!
 * dashify <https://github.com/jonschlinkert/dashify>
 *
 * Copyright (c) 2015 Jon Schlinkert.
 * Licensed under the MIT license.
 */
export function dashify(str: string) {
    if (typeof str !== 'string') {
        throw new TypeError('expected a string');
    }
    str = str.replace(/([a-z])([A-Z])/g, '$1-$2');
    str = str.replace(/[ \t\W]/g, '-');
    str = str.replace(/^-+|-+$/g, '');
    return str.toLowerCase();
}

globalSet('Utils.dashify', dashify);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/utils/dashify/dashify.ts